import { render, staticRenderFns } from "./CeremonyChapterNavigator.vue?vue&type=template&id=52f815c2&scoped=true"
import script from "./CeremonyChapterNavigator.vue?vue&type=script&lang=js"
export * from "./CeremonyChapterNavigator.vue?vue&type=script&lang=js"
import style0 from "./CeremonyChapterNavigator.vue?vue&type=style&index=0&id=52f815c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f815c2",
  null
  
)

export default component.exports